import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=349521fb&"
import script from "./Risk.vue?vue&type=script&lang=js&"
export * from "./Risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports